import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const ARTIFICIAL_TIME_DELAY = 3000;

const markFormAsArchive = async ({
	id,
	...payload
}: Partial<IAdminObservationForm>) => {
	const url = `/observations/admin/forms/${id}/`;

	const response = await cmsClient.patch<IAdminObservationForm>(url, payload);
	return response.data;
};

const useArchiveForm = () => {
	const queryClient = useQueryClient();

	const onMutate = () => {
		toast.info(<CustomToast type="Info" message="Deleting form..." />);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error deleting a form" />,
			{
				autoClose: false
			}
		);
	};

	const onSuccess = (data: IAdminObservationForm) => {
		queryClient.invalidateQueries(["observation-categories"]);

		window.setTimeout(() => {
			toast.success(
				<CustomToast
					type="Success"
					message={`Form "${data.name}" was deleted.`}
				/>
			);

			queryClient.invalidateQueries([
				"adminPublishedForms",
				"adminDraftForms",
				"publishedForms"
			]);
		}, ARTIFICIAL_TIME_DELAY);
	};

	const mutation = useMutation(markFormAsArchive, {
		onMutate,
		onError,
		onSuccess
	});

	return mutation;
};

export default useArchiveForm;
